import { UserRolesTypes } from 'common/enum/UserRoles';
import { addMainMenuItem } from 'common/helpers/menu';
import { getAppRootRegistry, getUserService } from 'common/interface/services';
import { ActiveFeaturesTypes } from 'common/enum/ActiveFeatures';
import { isSpectralEnabled } from 'common/utils/userPermissionUtils';
import { lazy } from 'react';

export const SPECTRAL_DEFAULT_PATH = '/spectral';

export default function initialize() {
    const SHIFTLLEFT_PAGE_REDIRECT_PATH = '/shiftleft-redirect';

    const SPECTRAL = {
        ID: 'NAVIGATION_MENU.SPECTRAL.TITLE',
        DEFAULT: 'NAVIGATION_MENU.SPECTRAL.DEFAULT.ID',
    };

    const defaultPageRoute = () => {
        return {
            exact: true,
            condition: getUserService().hasPermission([UserRolesTypes.ALL]),
            component: lazy(() => import('./SpectralPage')),
            path: SPECTRAL_DEFAULT_PATH,
        };
    };
    const spectralShiftLeftSelectorPageRidirect = () => {
        return {
            exact: true,
            condition: !getUserService().hasPermission([ActiveFeaturesTypes.SHIFTLEFT]),
            component: lazy(() => import('common/components/RedirectComponent/RedirectComponent')),
            componentProps: { to: SPECTRAL_DEFAULT_PATH, ignorePreviousSearchParams: true },
            path: SHIFTLLEFT_PAGE_REDIRECT_PATH,
        };
    };

    getAppRootRegistry().addRoutes([
        { id: SPECTRAL.DEFAULT, content: defaultPageRoute },
        {
            id: 'spectralShiftleftRedirect',
            content: spectralShiftLeftSelectorPageRidirect,
        },
    ]);

    addMainMenuItem({
        id: 'shiftleft spectral',
        position: 105,
        icon: 'shiftleft',
        label: SPECTRAL.ID,
        permission: () => isSpectralEnabled() && getUserService().hasPermission([ActiveFeaturesTypes.SPECTRAL]),
        state: SPECTRAL_DEFAULT_PATH,
        sections: [
            {
                id: 'default',
                position: 10,
                items: [
                    {
                        id: 'dashboard',
                        position: 10,
                        label: 'NAVIGATION_MENU.SPECTRAL.DASHBOARD',
                        state: SPECTRAL_DEFAULT_PATH,
                        permission: [ActiveFeaturesTypes.SPECTRAL],
                    },
                ],
            },
        ],
    });
}
